export default __webpack_public_path__ + "static/media/Eight.9516f000.svg";